import { get, isMockMode, simulateDelay } from "../api";

export const getProductById = ({ offeringId }) => {
	if (isMockMode()) {
		const testData = {
			numDaysToExpireLicenceCache: 30,
			licenceRefreshMinutes: 2,
			installers: [
				{
					id: 1,
					isDeleted: true,
					version: "v1.5",
					fileUri: "https://files.ingenious.tk/test.exe",
				},
				{
					id: 2,
					isDeleted: false,
					version: "2.2.3",
					fileUri: "",
				},
				{
					id: 3,
					isDeleted: true,
					version: "123",
					fileUri: "",
				},
				{
					id: 4,
					isDeleted: false,
					version: "v1.2",
					fileUri: "test",
				},
				{
					id: 5,
					isDeleted: false,
					version: "2",
					fileUri: "",
				},
				{
					id: 6,
					isDeleted: false,
					version: "",
					fileUri: "",
				},
			],
			currentInstaller: {
				id: 5,
				isDeleted: false,
				version: "2",
				fileUri: "",
			},
			id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
			name: "Test Name",
			description: null,
			ownerNotes: null,
			businessManagers: [
				{
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
					isActivated: true,
				},
			],
			offeringDevelopers: [
				{
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
					isActivated: true,
				},
			],
			techSupports: [
				{
					email: "test.mctestie@mgaol.abc",
				},
			],
			avatar: "data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=",
		};

		return simulateDelay(50, () => testData);
	}

	return get(`Products/AdminGetById?offeringId=${offeringId}`);
};
